import { Box } from "@primer/react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
//import DangKyDichVu from './dich-vu/DangKyDichVu';
//import { GiayToNopForm } from './giay-to-nop';
import { phuHuynhApi } from "../../api/phuHuynhApi";
import Modal from "../../components/ui/modal";
import QuanHeGiaDinhPhuHuynh from "./gia-dinh";
import { PhuHuynhProfileListTab } from "./list-tab";
import { PhuHuynhProfileTabs } from "./list-tab/PhuHuynhProfileListTab";
//import { ProfileForm } from './profile-form';

interface PhuHuynhProfileProps {
  id: number;
  value?: number;
  height?: number;
  phuHuynh?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const PhuHuynhProfile = (props: PhuHuynhProfileProps) => {
  const { id } = useParams<{ id: string }>();
  const [PhuHuynh, setPhuHuynh] = useState<any>({ id: props.id });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState<string>("dashboard");
  const componentDidMount = useRef(false);

  useEffect(() => {
    setPhuHuynh({ id: props.value });
  }, [props.value, id]);

  useEffect(() => {
    componentDidMount.current = true;
    if (PhuHuynh.id > 0) {
      handleGetPhuHuynhData();
    }
    return () => {
      componentDidMount.current = false;
    };
  }, [PhuHuynh.id]);

  const handleGetPhuHuynhData = async () => {
    setIsLoading(true);
    const res = await phuHuynhApi.getById(PhuHuynh.id);
    if (!componentDidMount.current) return;
    setIsLoading(false);
    if (res.is_success) {
      setPhuHuynh(res.data);
    }
  };

  const PhuHuynhProfileTab = useMemo(() => {
    return PhuHuynhProfileTabs.find((x) => x.id === selectedTab);
  }, [selectedTab]);

  // Chỉ hiện thanh tab khi có từ 2 tab trở lên
  const visibleTabs = PhuHuynhProfileTabs.filter((tab) => PhuHuynh.id > 0 || tab.id === "dashboard");

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      sx={{ width: "80%", maxWidth: "1280px" }}
      title={"Hồ sơ phụ huynh"}
    >
      {/* Bỏ padding mặc định của Dialog để 2 cột chạm mép */}
      <Box sx={{ m: -3, display: "flex", flexDirection: "column", height: props.height ?? window.innerHeight - 200 }}>
        {visibleTabs.length > 1 && (
          <Box sx={{ px: 3, flexShrink: 0 }}>
            <PhuHuynhProfileListTab
              selectedTab={selectedTab}
              PhuHuynhId={PhuHuynh.id}
              onTabSelectionChanged={setSelectedTab}
            />
          </Box>
        )}

        <Box sx={{ flex: 1, minHeight: 0 }}>
          {selectedTab === "dashboard" && (
            <QuanHeGiaDinhPhuHuynh id={PhuHuynh.id} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default PhuHuynhProfile;
